/**
 * 器のスキンの解放判定（トロフィーと同じ「全国の進み具合」から決める）。
 */

import { BOWL_SKINS, type BowlSkin } from '../game/config/bowlSkins';
import type { StorageLike } from '../game/systems/StorageSystem';
import { collectMetaProgress } from './progress';
import { MEDAL_RANK, medalOf, type MetaProgress } from './trophies';
import { Wallet } from './wallet';

export function isSkinUnlocked(
  skin: BowlSkin,
  progress: MetaProgress,
  extras: { adFree?: boolean } = {},
): boolean {
  if (skin.id === 'yatai') return true;
  if (skin.appOnly) return extras.adFree === true;
  if (skin.id === 'kintsugi') {
    return progress.prefs.filter((p) => MEDAL_RANK[medalOf(p)] >= MEDAL_RANK.gold).length >= 5;
  }
  if (!skin.regionId) return false;
  const pref = progress.prefs.find((p) => p.regionId === skin.regionId);
  return Boolean(pref && MEDAL_RANK[medalOf(pref)] >= MEDAL_RANK.bronze);
}

export function unlockedSkinIds(storage?: StorageLike | null): Set<string> {
  const progress = collectMetaProgress(storage);
  const adFree = new Wallet(storage).adFree;
  return new Set(BOWL_SKINS.filter((s) => isSkinUnlocked(s, progress, { adFree })).map((s) => s.id));
}
